// ui/atoms/Label.tsx
import styled from "styled-components";

export const Label = styled.label`
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};
`;

export const ErrorLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.danger};
`;

export const SuccessLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.success};
`;